import React, { useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import { btnSize, btnType } from '../styling/mixins/buttons';

interface ButtonProps {
  btnType: string;
  btnSize?: string;
  fullwidth?: boolean;
  as?: any;
  href?: string;
}

interface StyledButtonProps {
  $btnType: string;
  $btnSize: string;
  $fullwidth: boolean;
}

const StyledButton = styled.button<StyledButtonProps>`
  ${(p) => btnType(p.theme, p.$btnType)}
  ${(p) => btnSize(p.theme, p.$btnSize)}
  width: ${(p) => (p.$fullwidth ? '100%' : null)};
  opacity: ${(p) => (p.disabled ? '0.5' : '1')};
  cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};
  pointer-events: ${(p) => (p.disabled ? 'none' : 'default')};

  .icon + span,
  span + .icon {
    margin-left: 1.6rem;
  }

  .icon {
    font-size: 2.4rem;
  }
`;

const Button: React.FC<
  ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({
  btnType,
  btnSize = 'medium',
  fullwidth = false,
  as,
  href,
  ...props
}) => {
  const theme = useTheme();

  useEffect(() => {
    if (!theme.buttons.types.includes(btnType)) {
      console.warn(
        `The specified btnType "${btnType}" was not found for the current theme. Available types: [${theme.buttons.types.join(
          ', '
        )}]`
      );
    }
  }, [theme.buttons.types, btnType]);

  useEffect(() => {
    if (!theme.buttons.sizeClasses.includes(btnSize)) {
      console.warn(
        `The specified btnSize "${btnSize}" was not found for the current theme. Available sizes: [${theme.buttons.sizeClasses.join(
          ', '
        )}]`
      );
    }
  }, [theme.buttons.sizeClasses, btnSize]);

  return (
    <StyledButton
      as={as}
      $btnType={btnType}
      $btnSize={btnSize}
      $fullwidth={fullwidth}
      href={href}
      {...props}
    />
  );
};

export default Button;
